// Puerta de entrada al primer día guiado (ola 1 · W2d). Envuelve al Dashboard en
// App.js: la primera vez tras iniciar sesión pregunta al backend si la alumna tiene
// el flujo pendiente (ni completado ni descartado) y, solo entonces, redirige a
// /primer-dia. Nunca bloquea: sin token, sin profesión, con rol de administración,
// con error de red o pasado el tiempo límite se renderiza el Dashboard tal cual.
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageLoadingSkeleton from '../PageLoadingSkeleton';
import { getOnboarding, gateYaComprobada, marcarGateComprobada } from './onboardingApi';

export const GATE_TIMEOUT_MS = 4000;
// El primer día es para la alumna: los administradores nunca se redirigen.
export const ROLES_EXCLUIDOS = ['admin', 'super_admin'];

const leerToken = () => {
  try {
    return localStorage.getItem('session_token');
  } catch (_e) {
    return null;
  }
};

const OnboardingGate = ({ children, user }) => {
  const navigate = useNavigate();
  const token = leerToken();
  const necesitaComprobar = Boolean(
    user?.user_id && user?.selected_profession && token
    && !ROLES_EXCLUIDOS.includes(user?.role) && !gateYaComprobada(user.user_id)
  );
  const [comprobando, setComprobando] = useState(necesitaComprobar);
  const iniciada = useRef(false);

  useEffect(() => {
    if (!necesitaComprobar || iniciada.current) return;
    iniciada.current = true;
    // Pase lo que pase, una sola comprobación por pestaña y alumna.
    marcarGateComprobada(user.user_id);
    getOnboarding(false, { timeout: GATE_TIMEOUT_MS })
      .then((estado) => {
        if (estado?.should_redirect) {
          navigate('/primer-dia', { replace: true, state: { user } });
          return;
        }
        setComprobando(false);
      })
      .catch(() => setComprobando(false));
  }, [necesitaComprobar, navigate, user]);

  if (comprobando) {
    return <PageLoadingSkeleton />;
  }
  return React.isValidElement(children) ? React.cloneElement(children, { user }) : children;
};

export default OnboardingGate;
